import axios, { Method } from 'axios';
// AxiosRequestConfig.responseType?: "arraybuffer" | "blob" | "document" | "json" | "text" | "stream" | undefined
export const defaultApiUrl = 'http://localhost:8080';

const logAxiosError = (error: any, url: string, method: string, headers: any, body: any) => {
  // log error
  console.log(error, url, method, headers, body);
};

export const API = (
    method: Method,
    url: string,
    body: any = {},
    headers: any = {},
    contentType = 'application/json;charset=UTF-8',
    pathBaseUrl: string = defaultApiUrl
): Promise<any> => {
  const defaultHeaders = {
    'Content-Type': contentType
  };

  const setHeaders = {...defaultHeaders, ...headers};

  const req = axios({
    method,
    url: pathBaseUrl + url,
    headers: setHeaders,
    data: body,
  });

  return req
      .then((response: any) => {
       /* const { data , status } = response;
        let resp: any;
        switch (method) {
          case 'GET': {
            resp = data;
          } break;
          case 'POST': {
            resp = data;
          } break;
          case 'PUT':{
            resp = data;
          } break;
          case 'PATCH':{
            resp = data;
          } break;
          case 'DELETE':{
            resp = status;
          } break;
          default: {
            resp = data;
          }break;
        }*/
        return response;
      })
      .catch((error) => {
        logAxiosError(error, url, method, headers, body);
        throw error;
      });
};
